import {defineStore} from 'pinia'
import {config} from "@/core/config";
import {searchErrorLogger} from "@/core/Logger";
import {SortInterface} from "@/core/types";

import {useUrlStore} from "@/store/SerpPage/UrlStore";
import {usePaginationStore} from "@/store/SerpPage/PaginationStore";


const {apiHost, customerSymbol, searchId, apiKey} = config


export const useSortingStore = defineStore('SortingStore', {
  state: () => {
    return {
      sort: [] as SortInterface[],
      selectedSort: 'default'
    }
  },
  getters: {
    getSorting(state): SortInterface | Array<unknown> {
      return state.sort
    },
    getSelectedSortLabelById(state): string | undefined {
      return state.sort.find(sort => {
        return state.selectedSort === sort.id;
      })?.label
    },
  },
  
  actions: {
    getSessionStorageKey(): string {
      return `${searchId}_sortingOptions`
    },
    async fetchSortingOptions(): Promise<void> {
      const fromSessionStorage = this.getFromSessionStorage()
      if (fromSessionStorage) {
        this.sort = JSON.parse(fromSessionStorage)
        return
      }
      
      try {
        const response = await fetch(`https://${apiHost}/restapi/${customerSymbol}/search/${searchId}/sort`, {
          headers: {
            'Api-key': apiKey
          },
          credentials: 'include'
        });
        
        if (!response.ok) {
          throw new Error('Network response was not ok.');
        }
        
        this.sort = (await response.json()).sort
        this.saveToSessionStorage()
        
      } catch (error) {
        searchErrorLogger.log('Error in fetchSortingOptions:', error);
      }
    },
    saveToSessionStorage(): void {
      sessionStorage.setItem(this.getSessionStorageKey(), JSON.stringify(this.sort))
    },
    
    getFromSessionStorage(): string {
      return sessionStorage.getItem(this.getSessionStorageKey()) || ''
    },
    
    getSelectedSortFromUrl() {
      const urlParams = useUrlStore().decomposeUrl().searchParams
      return urlParams.get('s') || 'default'
    },
    
    
    updateSorting(event: Event) {
      const urlStore = useUrlStore()
      const paginationStore = usePaginationStore()
      paginationStore.resetPageValue()
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const selectedIndex = event.target.selectedIndex;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const selectedOption = event.target.options[selectedIndex];
      const name = selectedOption.getAttribute('name');
      
      this.selectedSort = name
      urlStore.updateSortParameter(name)
    },
  
    updateSortingOnClick(sort: SortInterface) {
      const {id} = sort
      const urlStore = useUrlStore()
      const paginationStore = usePaginationStore()
      paginationStore.resetPageValue()
      this.selectedSort = id
      urlStore.updateSortParameter(id)
    }
    
    
  },
})
